import { useEffect } from "react";

const SCROLL_AUTO_CLASS = 'scroll-auto';

export function usePreventScrollWhenModalIsOpen(preventScroll: boolean) {
    useEffect(() => {
        if (preventScroll) {
            document.body.classList.add(SCROLL_AUTO_CLASS);

            const preventScrollOnWheel = (e: WheelEvent) => e.preventDefault();
            const preventScrollOnTouchMove = (e: TouchEvent) => e.preventDefault();

            window.addEventListener("wheel", preventScrollOnWheel, { passive: false });
            window.addEventListener("touchmove", preventScrollOnTouchMove, { passive: false });

            return () => {
                window.removeEventListener('wheel', preventScrollOnWheel);
                window.removeEventListener('touchmove', preventScrollOnTouchMove);

                document.body.classList.remove(SCROLL_AUTO_CLASS);
            };
        }
    }, [preventScroll]);
}